import ClientServices from './Client/Services';

export const AccountServices = {
  ...ClientServices,
};
